<template>
  <article id="recognize_main">
    <error v-if="error" v-on:closeError="closeError" :errorMessage="errorMsg" />
    <article v-if="!stream && !error" id="request_container">
      <section id="request_section">
        <div id="logo_container">
          <h1 id="logo">Vegaani</h1>
          <h1 id="logo2">Kaveri</h1>
        </div>
        <button
          ref="req_btn"
          id="request_button"
          aria-label="Käynnistä VegaaaniKaveri"
          @click="startCamera"
        >
          <h1>Käynnistä VegaaniKaveri</h1>
        </button>
      </section>
    </article>
    <article v-show="stream" id="stream_container">
      <video id="the_stream" ref="video" autoplay muted playsinline />
      <section id="cam_controls">
        <button
          ref="cap_btn"
          class="btn"
          id="capture"
          aria-label="Ota kuva VegaaniKaverille"
          v-if="ready"
          @click="capturePhoto"
        >
          <svg
            id="camera_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14.75 19.87"
          >
            <path
              d="M82.9 109.1c.33-.1.7-.1 1.03 0 .34.08.66.16.91.5a2 2 0 01.38 1.17c0 .42-.13.88-.4 1.2-.25.32-.56.4-.89.49-.33.08-.7.08-1.03 0-.34-.09-.66-.16-.9-.49a1.98 1.98 0 01-.38-1.18c0-.42.11-.88.38-1.21.22-.26.57-.4.9-.49z"
              fill="#34655d"
              stroke="#000"
              stroke-width=".49"
              aria-label="Ota kuva VegaaniKaverille"
              font-size="40"
              font-family="monospace"
              transform="matrix(.7322 0 0 .70481 -54 -59.61)"
            />
            <path
              d="M7.8 13.65l-.0313 1.5897c0 .2962-.0487.7403-.1987.9103a.76.76 0 01-.6.25.79.79 0 01-.6-.25c-.15-.17-.23-.45-.23-.84 0 0 .0362-2.01 0-2.76-.0125-2.4238 3.187-2.7408 5.84-3.16.6289-.1494.901-1.377.88-2.2 0-1.46-.54-2.7-1.6-3.74S9.227 1.9558 7.34 1.97c-.9031.0263-1.7923.0719-2.6721.0995-.8333.0312-2.7736.1103-2.7479 1.2105v1.68c.0216.3966-.08.67-.23.84a.73.73 0 01-.59.25.76.76 0 01-.59-.25c-.15-.17-.23-.45-.23-.84 0 0-.06-2 0-2.76C.39.9 2.8513.526 3.7279.4216 4.9431.277 6.2389.2721 7.2589.2721 9.439.2721 11.19.9 12.51 2.2c1.32 1.3 1.99 2.95 1.99 4.94 0 1.23-.4 2.32-1.2 3.27-1.164 1.1312-5.5793.387-5.5 3.24z"
              style="line-height:1.25;-inkscape-font-specification:monospace"
              font-size="40px"
              font-family="monospace"
              fill="#40ae82"
              stroke="#000"
              stroke-width="0.5"
            />
          </svg>
        </button>
        <button
          id="toresults"
          aria-label="Siirry VegaaniKaverin tuloksiin"
          v-if="ready"
          @click="disp_res = true"
        >
          Tulokset
        </button>
      </section>
    </article>
    <loading v-if="loading" />
    <article v-show="disp_res">
      <result
        :recognized="found"
        :images="captures"
        v-on:closeResult="closeResult"
      />
    </article>
    <section v-show="!stream && !error" id="doodle_container">
      <svg
        v-if="!stream"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 106.74488 83.499893"
        version="1.1"
        id="doodle"
      >
        <path
          id="doodle_path"
          fill="none"
          fill-rule="evenodd"
          stroke="#009289ff"
          stroke-width=".3"
          d="M59.9628 23.3258c-.0562.1618-.2492.2233-.4005.162-.2016-.0817-.2762-.3267-.1913-.5187.1066-.2413.4044-.329.6368-.2206.2813.1314.3822.4823.2499.755-.156.3213-.5601.4355-.8732.2792-.3613-.1804-.4888-.638-.3085-.9913.2049-.4014.716-.5421 1.1095-.3378.4217.219.5852.7482.3924 1.1758m0 0c-.8296 2.4476.6432 5.1067 3.0562 5.9038 2.7208.8989 5.6654-.7422 6.534-3.4277.3614-1.1176.3508-2.3392-.0166-3.4538m-30.2668 8.1362c-.5724-.589-.3044-1.5429.2965-1.9962.9181-.6926 2.221-.2919 2.824.6168.8213 1.238.2813 2.9042-.9372 3.6518-1.5544.9538-3.5895.2718-4.4795-1.2574-1.0881-1.8696-.2628-4.2762 1.5777-5.3073 2.184-1.2236 4.9636-.2542 6.1351 1.898 1.3598 2.4978.2458 5.6514-2.2183 6.9629-2.8114 1.4963-6.3396.2376-7.7907-2.5386-1.6333-3.1248-.2295-7.0282 2.8589-8.6185.8161-.4203 1.717-.6702 2.6324-.735m42.7974 2.78c-2.0766-3.234-7.6034-2.0124-8.286 1.7251-1.1666 3.903 3.2152 7.6299 6.9237 6.1347 2.0416-.6548 3.5395-2.5792 3.7912-4.6918m-7.1524-9.2655c3.0346-1.0676-2.4602-2.5935-.4728.25 3.594 1.1185.6933-4.7555-.8458-1.2209l.007.7345.3497.6465m4.1359-1.034c2.341-1.1457-1.7664-2.6861-.9202-.2084m-9.8797 2.505c-.5627-.194-1.0991.2579-1.08.8321m-.6723.7782c.3694-.0536.6684-.393.6722-.7782m2.627.9747c.01-.875-.6905-1.6692-1.547-1.8067M59.3857 18.046c.9068 4.118 6.3151 6.1566 10.0936 5.3838m-3.875-10.8357c-4.0441.2895-5.681 6.0218-2.5562 8.5281 3.0641 3.0923 8.7742.8388 9.2716-3.3806 1.0214-4.7855-4.7367-8.8505-8.9844-6.6052-2.592 1.1792-4.2397 4.0802-3.9496 6.9096m6.2185-5.4518c3.7025-.0354 5.2688-5.3321 2.3318-7.5043-2.8993-2.7472-8.036-.1772-7.9738 3.7017-.3364 4.4838 5.6363 7.3054 8.9672 4.349 1.4853-1.1514 2.3826-3.0236 2.3137-4.9058m2.5093-1.7156c-4.6195 1.0193 1.3147 6.2669 2.2758 1.9698.5665-3.3913-4.811-3.5873-4.785-.2542m6.055 3.4769c.0326-5.3691-8.5648-4.1944-7.6535.8795.2654 3.706 5.4682 5.2904 7.8293 2.4563 3.1137-3.1052.5298-8.53-3.7368-8.5292m3.561 5.1934c.2984 5.369 8.2386 4.0863 7.514-.9915m3.972 1.0595c3.8218-2.141-3.0234-5.0237-2.6818-.9164.6342 4.5678 7.5136.8898 4.4437-2.4143-1.9233-2.383-5.8382-.6802-5.734 2.2712m15.7614 1.6297c3.5246-1.4 3.0254-6.9622-.4427-8.134-3.8088-1.8138-8.2938 1.906-7.748 5.9548.2051 5.0903 6.804 7.7892 10.7896 4.9045 4.9692-3.0405 4.3855-11.1378-.6891-13.7377-4.7205-2.8971-11.5256-.3013-13.1748 4.995-.6264 1.708-.775 3.5907-.4032 5.373m5.5525 2.2813c-3.0668 3.6273 4.6352 6.1118 4.902 1.4892.7267-4.9757-7.326-5.1368-7.5295-.4486-.6438 3.7394 4.0699 6.4487 7.1116 4.3525 2.3718-1.3584 3.1162-4.6515 1.7915-6.9866m-6.4828 7.6685c.9652 4.5615 8.2982 4.2292 9.3292-.1765 1.6054-4.5068-3.7576-8.9018-7.9137-6.6538l-.6266.3394-.5818.416m-.2071 6.0749c-1.2899-5.0603-7.0061 2.5474-1.3472 2.411l.6292-.168m0 0c4.7565-1.472.4065-8.9828-3.3625-5.926-1.971 1.212-2.3824 4.2635-.79 5.9467m-3.3723 1.3008c1.0415-2.856 3.586 7.128 5.102 2.6556.4262-1.5447-.6855-2.96-1.7297-3.9564M78.9358 39.9602c.119-2.8388-3.9024.988-.38.9007m5.3458 9.4015c-1.4322-2.1613-.826 2.437.4313.1027.2423-2.5327-3.4285-.5844-1.5407.813m-9.9765 19.18l-.0371-46.7318M86.0449 70.358l-.0371-46.7317M72.8157 70.3581c-.5426 6.9035-7.346 11.2506-13.5743 12.5428-2.059.4398-3.6976.3464-5.6724.3556M86.045 70.358c1.032 9.0499 11.701 13.757 19.8573 12.8984m-81.209-56.1618c.9852-1.2596 2.8628-1.365 4.0804-.3852 1.4265 1.148 1.5376 3.2984.3974 4.685-1.3103 1.5935-3.734 1.7102-5.2893.4096-1.7608-1.4725-1.8832-4.17-.422-5.8938 1.6346-1.9282 4.606-2.0562 6.4983-.4342 2.0957 1.7964 2.2293 5.042.4465 7.1027-1.9582 2.2633-5.4781 2.4025-7.7071.4587-1.0595-.9238-1.7462-2.2319-1.922-3.625m7.1525-9.2656c-.3997.1213-.8169-.138-.93-.5302-.1327-.4595.1663-.9358.6181-1.061.5193-.144 1.055.1948 1.1922.7062.1554.5791-.2233 1.174-.7944 1.3232-.6388.167-1.2932-.2517-1.4543-.8825-.1783-.6985.2802-1.4124.9706-1.5853.7583-.1899 1.5317.3087 1.7164 1.0587.12.4868-.0198 1.0116-.3568 1.381m-4.1358-1.034c-.4173-.042-.7149-.4357-.6714-.8472.0481-.4542.4775-.7775.9258-.7281.4911.054.8403.5192.785 1.0045a.9454.9454 0 01-.1192.3624m9.8797 2.505c.6945-.1116.8907.1692 1.0107.4777a.977.977 0 01.0694.3544m.6722.7782c-.3805-.058-.664-.3963-.6722-.7782m-2.627.9747c.001-.8903.6764-1.6558 1.547-1.8067m11.8457-3.7736c-.3348 2.5043-3.1344 4.4024-5.6655 5.1625-1.4275.4386-2.964.5213-4.428.2213m3.875-10.8356c2.6243.272 4.4694 2.7674 4.1831 5.3474-.3215 2.8976-3.0843 4.93-5.9379 4.5965-3.1708-.3707-5.3908-3.4013-5.0097-6.5284.4197-3.4442 3.7182-5.8517 7.1188-5.423 3.6211.4564 6.201 3.8633 5.8642 7.4593m-6.2185-5.4518c-2.2719-.0947-3.9916-2.1432-3.8824-4.3777.1226-2.5096 2.3912-4.4048 4.8636-4.2694 2.7473.1504 4.818 2.6394 4.6563 5.3496-.178 2.985-2.8876 5.2312-5.8356 5.0432-3.1391-.2003-5.5394-2.9939-5.4408-6.105M33.033 6.5192c.9696-.0163 1.7528.813 1.762 1.7672.0103 1.0715-.9084 1.9349-1.9644 1.9388-1.1735.004-2.117-1.0038-2.1157-2.1617.0015-1.2753 1.0992-2.2991 2.359-2.2925 1.3415.007 2.433 1.1368 2.4684 2.4638m-6.055 3.4769c-.031-2.0087 1.689-3.6288 3.6656-3.6451 2.2197-.0183 4.0056 1.8872 4.0108 4.0748.0058 2.4308-2.0852 4.3826-4.4839 4.3766-2.6419-.007-4.7597-2.2833-4.7423-4.893.0184-2.779 2.3616-5.037 5.1107-5.1067m-3.561 5.1934c-.0015 1.9763-1.7193 3.5425-3.6638 3.527-2.1837-.0172-3.91-1.9201-3.8803-4.072a4.1843 4.1843 0 01.0302-.4465m-3.972 1.0595c-.8226-.1564-1.2923-1.0238-1.118-1.8138.2179-.9874 1.2687-1.545 2.2246-1.314 1.1522.2782 1.798 1.5136 1.51 2.6353-.338 1.317-1.7587 2.0515-3.046 1.706-1.482-.3976-2.3051-2.0039-1.902-3.4567.4569-1.6472 2.249-2.559 3.8674-2.0982 1.4455.4117 2.4346 1.7903 2.436 3.282M6.2118 12.35c-2.1985-.9128-3.0024-3.5988-2.059-5.6963 1.1791-2.6213 4.4267-3.5633 6.953-2.3663 3.045 1.4428 4.1257 5.2553 2.6737 8.2097-1.7051 3.4692-6.0844 4.6888-9.4664 2.9809C.4192 13.5115-.9395 8.564 1.025 4.755 3.2521.436 8.7685-1.0618 13.0046 1.1594c3.7838 1.9841 5.7367 6.3942 4.8755 10.5462m-5.5525 2.2814c.961.8864.8688 2.4235-.0142 3.3272-1.102 1.1277-2.9526 1.0012-4.0284-.092-1.2954-1.3163-1.1342-3.4822.1698-4.7296 1.53-1.4636 4.0123-1.2674 5.4307.2477 1.6322 1.7433 1.401 4.5426-.3254 6.1318-1.9564 1.801-5.0732 1.5347-6.833-.4032-1.4978-1.6492-1.7366-4.1335-.6751-6.0755m6.4828 7.6685c-.6761 3.639-6.1613 4.4389-8.2996 1.594-2.5947-2.8057-.9801-7.8323 2.7182-8.7125 1.8272-.584 3.8912-.1657 5.3742 1.0436m.2072 6.075c.3903-3.7877 5.9257-.568 3.1484 1.8214-.637.6046-1.6268.7746-2.4304.4215m0 0c-4.4931-1.5322-1.0293-8.381 2.9497-6.1463 2.3085 1.0399 2.9134 4.3257 1.2027 6.167m3.3724 1.3009c-.1046-4.0478-4.0023 7.7095-5.102 2.6556-.4245-1.5174.6613-2.9415 1.7296-3.9564m13.347 41.4647c3.2264.7752-1.6093 3.9223-1.2115.5567.1306-.4558.5153-.8268.9763-.9394m-2.2938-23.4799c1.5186.0524-1.268-4.116 1.6414-.9801.6244.8973-.0258 2.255-1.1103 2.3582m-6.3018 9.0593c-.1863-2.4763 3.3627-.7227 1.5407.813m9.9765 19.18l.0372-46.7318M20.7405 70.3581l.0371-46.7317m13.1921 46.7317c.3922 6.1416 5.8347 10.3325 11.2871 12.0087 2.6773.8335 5.5667.915 8.3122.8897M20.7405 70.358c-.5833 6.4135-6.6038 10.7385-12.4072 12.2688-2.418.6507-4.9565.9079-7.4501.6296"
        />
        />
      </svg>
    </section>
  </article>
</template>

<script>
import axios from "axios";
import result from "../components/result.vue";
import loading from "../components/loading.vue";
import error from "../components/error.vue";

export default {
  name: "recognize",
  components: { result, loading, error },
  data: function() {
    return {
      loading: false,
      results: [],
      stream: null,
      ready: false,
      height: null,
      width: null,
      disp_res: false,
      error: false,
      errorMsg: "",
      captures: [],
      targets: [],
      kohteet: [],
      found: [],
      header: {
        /*Google cloud vision API request header*/
        requests: [
          {
            features: [
              {
                type: "DOCUMENT_TEXT_DETECTION"
              }
            ],
            image: {
              content: null
            },
            imageContext: {
              languageHints: ["fi"]
            }
          }
        ]
      }
    };
  },
  mounted() {
    const TARGETS = require("../targets/nonVegan");
    const EKOODIT = [];
    const NIMET = [];
    for (const TARGET of TARGETS) {
      EKOODIT.push(TARGET.ekoodi);
      NIMET.push(TARGET.nimet);
    }
    const MOLEMMAT = EKOODIT.concat(NIMET);
    /*Push both the names and e-codes of non-vegan ingredients to one single "targets" array*/
    this.targets.push(MOLEMMAT);
  },
  methods: {
    /*Let's bootup the camera when our user accepts the camera permissions*/
    async startCamera() {
      this.$refs.req_btn.animate(
        //just a simple button push animation
        [
          { transform: "translateY(-0.25em)" },
          { transform: "translateX(-0.25em)" },
          { filter: "none" }
        ],
        { duration: 150 },
        (this.loading = true)
      );
      /*start the stream from users camera*/
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({
          audio: false,
          video: {
            facingMode: "environment",
            width: { ideal: 1920 },
            height: { ideal: 1080 },
            frameRate: { ideal: 60 }
          }
        });
      } catch (err) {
        const x = err.toString().toLowerCase();
        this.errorMsg = x;
        this.error = true;
        this.loading = false;
        return;
      }
      this.$refs.video.srcObject = this.stream;
      let track = this.stream.getVideoTracks()[0];
      const capabilities = track.getCapabilities(); //get device capabilities so we can apply good resolution for OCR
      /*Good resolution for performance/recognition ratio is 1024x768, if the device isn't capable of this resolution we use the highest available resolution*/
      if (capabilities.width["max"] >= 1024) {
        this.width = 1024;
      } else if (capabilities.width["max"] < 1024) {
        let x = track.getSettings();
        this.width = x.width;
      }
      if (capabilities.height["max"] >= 768) {
        this.height = 768;
      } else if (capabilities.height["max"] < 768) {
        let x = track.getSettings();
        this.width = x.height;
      }
      /*continue*/
      this.$refs.video.onloadedmetadata = e => {
        this.ready = true;
        this.loading = false;
        return e;
      };
      this.$refs.video.onended = e => {
        this.ready = false;
        this.stream = null;
        this.loading = false;
        return e;
      };
    },
    capturePhoto() {
      /*Here we capture the photo for OCR*/
      let video = this.$refs.video;
      let canvasCapture = document.createElement("canvas"); //canvas element to store our capture data
      canvasCapture.height = this.height;
      canvasCapture.width = this.width;
      let videoContents = canvasCapture.getContext("2d");
      videoContents.drawImage(
        video,
        0,
        0,
        canvasCapture.width,
        canvasCapture.height
      );
      const base64 = canvasCapture.toDataURL();
      const finalImage = base64.replace("data:image/png;base64,", "");
      this.header.requests[0].image.content = finalImage;
      this.loading = true;
      /*And then we send the processed capture to cloud vision OCR*/
      axios
        .post(
          `https://eu-vision.googleapis.com/v1/images:annotate?key=${process.env.VUE_APP_APIKEY}`,
          this.header
        )
        .then(response => {
          const RESULT = response.data.responses[0].textAnnotations;
          if (RESULT) {
            for (let x = 0; RESULT.length > x; x++) {
              this.results.push(RESULT[x].description); //push words to results array
            }
            this.findTargets(); //function that finds our target words
            this.captures.push(finalImage); //push captured image to captures array
            RESULT.length = 0;
          } else {
            this.loading = false;
            //eslint-disable-next-line no-console
            console.log("Ei löytynyt tekstiä");
          }
        })
        .catch(error => {
          //eslint-disable-next-line no-console
          console.log(error);
          this.loading = false;
        });
    },
    findTargets() {
      /*here we find intersection values of result and target arrays and remove duplicate values*/
      let tulokset = JSON.parse(JSON.stringify(this.results));
      this.results = tulokset.map(e => e.toLowerCase()); //convert to lowercase for case-insesitivity
      let maalit = this.targets[0].flat(1);
      this.kohteet = maalit.map(e => e.toLowerCase()); //convert to lowercase for case-insesitivity
      const intersection = this.kohteet.filter(e => this.results.includes(e)); //match target words that don't include space in the word, example 'e120'
      const intersection2 = this.kohteet.filter(e =>
        this.results[0].includes(e)
      ); //match target words that include space in the word, example: 'e 120'
      //eslint-disable-next-line no-console
      console.log(intersection);
      const finalIntersection = intersection.concat(intersection2); //make on array of both intersections
      const ready = [...new Set(finalIntersection)]; //remove duplicate values
      this.disp_res = true; //display results
      this.found.push(ready.join(", "));
      this.results = []; //and finally, make results array ready for the possible next round
      this.loading = false;
    },
    closeResult(value) {
      this.disp_res = value;
    },
    closeError(value) {
      this.error = value;
    }
  }
};
</script>
<style lang="scss" scoped>
#recognize_main {
  display: flex;
  flex-direction: column;
  min-width: 100vw;
  max-width: 100%;
  min-height: 100vh;
  max-height: 100%;
}
article {
  justify-content: center;
}
#request_container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100vw;
  max-width: 100%;
  height: 100vh;
  min-height: -webkit-fill-available;
}
#request_section {
  display: flex;
  justify-content: center;
  background-color: #1c5f51;
  margin: 0 auto;
}
#logo_container {
  position: absolute;
  top: 1em;
  background-color: #00000015;
  padding: 0.5em;
  border: 0.1em solid black;
  border-radius: 0.75em;
}
#logo {
  font-size: 3.5em;
  color: #40b782ff;
}
#logo2 {
  font-size: 3.5em;
  color: #344a5dff;
}
#doodle_container {
  position: relative;
  margin: 0 auto;
}
#doodle {
  position: absolute;
  max-height: 25vh;
  bottom: 0;
  margin: 0 auto;
}
#doodle_path {
  stroke-dasharray: 50;
  animation: draw 150s linear infinite, draw_color 5s linear infinite;
}
#request_button {
  all: unset;
  cursor: pointer;
  height: 7em;
  padding: 1em;
  margin: auto;
  border: 0.1em solid black;
  color: white;
  filter: drop-shadow(-0.25em -0.25em rgb(34, 34, 34));
  background-color: rgba($color: #004146, $alpha: 0.97);
  border-radius: 3em;
}
#stream_container {
  all: unset;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 100vw;
  max-width: 100%;
  min-height: 100vh;
  max-height: 100%;
}
#the_stream {
  border: 0.1em solid black;
  width: 100vw;
  max-width: 100%;
  justify-content: center;
  margin: 0 auto;
  z-index: 10;
}
#cam_controls {
  all: unset;
  position: absolute;
  bottom: 1em;
  display: flex;
  height: 100%;
  width: 100%;
  max-height: 25vh;
  border-top: 0.1em solid black;
  background-color: rgba($color: #003026, $alpha: 0.5);
  flex-direction: row;
  justify-content: center;
  z-index: 11;
}
#camera_icon {
  vertical-align: middle;
  max-height: 5em;
}
#toresults {
  all: unset;
  position: absolute;
  right: 0;
  font-size: 1em;
  max-height: 2.5em;
  cursor: pointer;
  color: white;
  background-color: #003026;
  border: 0.1em solid black;
  border-radius: 0 0 0 0.5em;
  padding: 1em;
}
.btn {
  all: unset;
  display: inline-block;
  text-align: center;
  color: white;
  text-transform: uppercase;
  border: 0.1em solid black;
  height: 5em;
  width: 5em;
  margin: 2.5em auto;
  padding: 1.5em;
  border-radius: 100%;
  background: rgba(0, 105, 91, 0.9);
  background: radial-gradient(
    circle,
    rgba(0, 105, 91, 0.9) 0%,
    rgba(0, 66, 57, 0.9) 100%
  );
}
.btn > p {
  margin: 0 auto;
}
@keyframes draw {
  to {
    stroke-dashoffset: 1000;
  }
}
@keyframes draw_color {
  0% {
    stroke: #009289ff;
  }
  50% {
    stroke: #40b782ff;
  }
  100% {
    stroke: #009289ff;
  }
}
@supports (-webkit-text-stroke: 0.025em black) {
  #logo {
    -webkit-text-stroke: 0.025em black;
  }
  #logo2 {
    -webkit-text-stroke: 0.025em black;
  }
}
</style>
